function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2883 8.92508L17.7633 6.45008C18.8112 5.49499 20.1868 4.98038 21.6042 5.0132C23.0217 5.04601 24.372 5.62373 25.3746 6.62629C26.3771 7.62886 26.9549 8.97917 26.9877 10.3966C27.0205 11.8141 26.5059 13.1897 25.5508 14.2376L22.0133 17.7626C21.5035 18.2743 20.8976 18.6804 20.2305 18.9574C19.5634 19.2345 18.8481 19.3771 18.1258 19.3771C17.4034 19.3771 16.6882 19.2345 16.0211 18.9574C15.354 18.6804 14.7481 18.2743 14.2383 17.7626",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7126 23.0751L14.2376 25.5501C13.1897 26.5052 11.8141 27.0198 10.3966 26.987C8.97917 26.9541 7.62886 26.3764 6.62629 25.3739C5.62373 24.3713 5.04601 23.021 5.0132 21.6035C4.98038 20.1861 5.49499 18.8105 6.45008 17.7626L9.98758 14.2376C10.4974 13.7258 11.1033 13.3198 11.7704 13.0427C12.4375 12.7657 13.1527 12.623 13.8751 12.623C14.5974 12.623 15.3127 12.7657 15.9798 13.0427C16.6469 13.3198 17.2528 13.7258 17.7626 14.2376",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Link.72bbb55d.svg";
export { ForwardRef as ReactComponent };